import { AccessProvider } from '../../../contexts/accessProvider.tsx';
import { CategoriesContextProvider } from '../../../contexts/categories/categories.tsx';
import { Role } from '../../../models/enums/role.ts';
import CategoriesBody from './body.tsx';
import CategoriesHeader from './header.tsx';

const Categories = () => {
    return (
        <AccessProvider roles={[Role.admin, Role.superAdmin]}>
            <CategoriesContextProvider>
                <CategoriesHeader />
                <CategoriesBody />
            </CategoriesContextProvider>
        </AccessProvider>
    );
};

export default Categories;
